import { render, staticRenderFns } from "./SignupWizardStepSelectPlan.vue?vue&type=template&id=d5f64c1a&scoped=true&"
import script from "./SignupWizardStepSelectPlan.vue?vue&type=script&lang=js&"
export * from "./SignupWizardStepSelectPlan.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizardStepSelectPlan.vue?vue&type=style&index=0&id=d5f64c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f64c1a",
  null
  
)

export default component.exports